import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UiServiceWebSession } from '@drct-web-apps/ui-services';
import { ReplaySubject, takeUntil } from 'rxjs';



@Component({
  selector: 'ui-web-home-schedule',
  templateUrl: './ui-web-home-schedule.component.html',
  imports: [ CommonModule]
})
export class UiWebHomeScheduleComponent implements OnInit, OnDestroy {
  private readonly destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  public winter_schedule = false;

  constructor(private readonly webSession: UiServiceWebSession) {}
  
  ngOnInit(): void {
    this.winter_schedule = this.webSession.webConfig?.winter_schedule ?? false;

    this.webSession.sessionReady
                   .pipe(takeUntil(this.destroyed$))
                   .subscribe((ready: boolean) => {
                      if(ready) {
                        this.winter_schedule = this.webSession.webConfig?.winter_schedule ?? false;
                      }
                   });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
